<template>
  <b-navbar toggleable="lg" type="dark" variant="info">
    <div class="container">
      <b-navbar-brand class="text-white">
        <!-- <b-link class="text-white" to="home">Home</b-link> -->
         <router-link class="text-white" to="/home">Home</router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <ul class="navbar-nav mr-auto">
          <!-- <li v-if="!isLoggedIn" :class="[currentPage.includes('dashboard') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/register">Register</router-link>
          </li>
          <li v-if="!isLoggedIn" :class="[currentPage.includes('dashboard') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/login">Login</router-link>
          </li>-->
          <li v-if="isLoggedIn" :class="[currentPage.includes('dashboard') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
          </li>
          <li v-if="isLoggedIn" :class="[currentPage.includes('videos') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/videos">Videos</router-link>
          </li>
          <li v-if="isLoggedIn" :class="[currentPage.includes('playlist') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/playlist">Playlist</router-link>
          </li>
          <li v-if="isLoggedIn" :class="[currentPage.includes('advertising') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/advertising">Advertising</router-link>
          </li>
          <li v-if="isLoggedIn" :class="[currentPage.includes('Analytcs') ? 'active': '', 'nav-item']">
            <router-link class="nav-link" to="/Analytcs">Analytcs</router-link>
          </li>   
          <li v-if="isLoggedIn" :class="[currentPage.includes('categories') ? 'active': '', 'nav-item']">
         <router-link  class="nav-link" to="/categories">Categories</router-link>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li v-if="isLoggedIn" class="nav-item">
            <a @click="logout" class="nav-link" href="#">Logout</a>
          </li>
          <li v-if="!isLoggedIn" class="nav-item">
            <a href="https://veido.de" class="nav-link">Login/Register</a>
          </li>
        </ul>
      </b-collapse>
    </div>
    <!-- </nav> -->
  </b-navbar>
</template>

<script>
export default {
  name: "navbar",

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
    // loginRegister() {
    //   window.location.reload();
    //   // this.$router.go();
    // },

    logout() {
      localStorage.removeItem("token");
      this.$router.go();
      window.location.reload();
    }
  }
};
</script>
